import { useState } from "react";
import Modal from "../../../NewCompany/CompanyModal";
import ghgView from "../../../../assets/design-revamp-company/company-intro/ghg-view.svg";
import ghgImageDa from "../../../../assets/design-revamp-company/company-component/ghg-protocol-da.svg";
import ghgImage from "../../../../assets/design-revamp-company/company-component/ghg-protocol.svg";
import backButton from "../../../../assets/design-revamp-company/company-component/Back_Button.svg";
import { useTranslation } from "react-i18next";

const GHGView = () => {
  const [isOpen, setIsOpen] = useState();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: "80vw",
      }}
    >
      <img
        src={ghgView}
        alt="GHG Protocol"
        onClick={openModal}
        style={{ cursor: "pointer", width: "100%" }}
      />
      {isOpen && (
        <Modal
          imageSrc={currentLanguage === "en" ? ghgImage : ghgImageDa}
          altText="GHG Protocol"
          onClose={closeModal}
          closeBtn={backButton}
          closeBtnWidth={40}
          closeBtnHeight={40}
        />
      )}
    </div>
  );
};

export default GHGView;
